import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { DialogPermissionComponent } from '../dialog/dialog-permission.component';
import { DialogContractorUnlistedComponent } from '../dialog/dialog-contractorunlisted.component';
import { AppSheetContractorComponent } from '../../chrome/app-sheet-contractor.component';
import { mergeMap, map, defaultIfEmpty } from 'rxjs/operators';



import {
  AuthenticationService,
  ApplicationApiService,
  ContractorReviewApiService,
  AnnotationApiService,
  ApplicationBidApiService,
  ContractorHireHistoryApiService,
  ContactApiService,
  ApprovalTaskItemApiService,
  CrossSiteNavigationService
} from '../../data-services/index';

import {
  IApplication,
  IApplicationInput,
  IContactInput,
  IContractor,
  IUser,
  IContractorReview,
  IContractorReviewInput,
  ContractorApiService,
  IAnnotationInput,
  IApplicationBidInput,
  IApplicationBid,
  IContractorHireHistoryInput,
  UtilityService,
  IContractorHireHistory,
  IApprovalTask,
  IHelp,
  IApprovalTaskItem,
  AppLoadService,
  IContact
} from '@ebb-v2/ebb-integration';

import {
  DialogContractorReviewData,
  DialogContractorReviewComponent
} from '../dialog/dialog-contractorreview.component';
import { blobToBase64String } from 'blob-util';
import { DialogUploadApplicationBidComponent, DialogUploadApplicationBidData } from '../dialog/dialog-upload-applicationbid.component';
import { isNull } from 'util';
import { DialogContractorReviewListComponent, DialogContractorReviewListData } from '../dialog/dialog-contractorreviewlist.component';
import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';
import { forkJoin, from, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
    selector: 'ebb-portal-contractor-form',
    templateUrl: './contractor-form.component.html',
    standalone: false
})
export class ContractorFormComponent implements OnInit {
  @Input('application') application: IApplication;
  @Input('taskBuildingPermit') taskBuildingPermit: IApprovalTask;
  @Input('taskSG') taskSG: IApprovalTask;
  @Input('w9Shown') w9Shown: boolean;
  @Output() emitContractorUpdateEvent = new EventEmitter<IApplicationInput>();
  @Output() emitContractorFileUploadEvent = new EventEmitter<IApprovalTask>();
  @Output() emitBidInvoiceFileUploadEvent = new EventEmitter<IApprovalTask>();
  @Output() emitBidInvoiceInitEvent = new EventEmitter<boolean>();
  public currentUser: IUser;

  public formContractorInfo: FormGroup;
  public taskRetrofitContractorTitle = 'Contractor Information';
  public taskRetrofitContractorStatus = 'Pending';
  public taskRetrofitContractorSummary = 'Select contractor';
  public taskRetrofitContractorGrantPerm = 700000000;
  public selectRetrofitContractor = 0;
  public formAutoSave = false;
  public contractorReview: IContractorReview = null;
  public contractorReviews: IContractorReview[] = null;
  public retrofitContractor: IContractor = null;
  public currentDate: Date = new Date();
  public bidUploadResult;
  //TODO: replace the following variable with the previous one, across the board...
  //NOTE: prior to implementing the 'thisContext' constant, the previous one was used to help with the context switching...
  public bidUploadResultContext;
  public bid1;
  public bid2;
  public displaySecondBid = false;
  public displaySecondBidLabel: string;
  public displayFirstBidLabel = 'SUBMIT ESTIMATE';
  
  public openOption: string;
  public bidContractorName: string;
  public apiApplicationBidService: ApplicationBidApiService;
  public apiContractorHireHistoryService: ContractorHireHistoryApiService;
  public saveBidProgressIndicator = false;
  public saveEngBidProgressIndicator = false;
  public bid1rejected = false;
  public bid1rejectedwhy: string;
  public trainingUrl: string;
  public programCycleContractorAllowManual: boolean;
  public bids: IApplicationBid[];
  public waitForFileToUpload = -1;
  public showesstraining: boolean;
  public estimatemax = 10000;
  constructor(
    private readonly fb: FormBuilder,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly dialogUpload: MatDialog,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiContractor: ContractorApiService,
    private readonly apiContact: ContactApiService,
    private readonly infoSheet: MatBottomSheet,
    private readonly dialogPermission: MatDialog,
    private readonly dialogContractorUnlisted: MatDialog,
    private readonly dialogContractorReview: MatDialog,
    private readonly dialogContractorReviewList: MatDialog,
    private readonly apiContractorReview: ContractorReviewApiService,
    private readonly apiApplicationBid: ApplicationBidApiService,
    private readonly apiContractorHireHistory: ContractorHireHistoryApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly appLoadService: AppLoadService,
    private readonly xSiteNavigationService: CrossSiteNavigationService,
    private readonly snackBar: MatSnackBar,
    public readonly utilityService: UtilityService,
    private readonly actRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
  if(this.application.programCycle.maxBidAmount != null &&  this.application.programCycle.maxBidAmount>0){

    this.estimatemax = this.application.programCycle.maxBidAmount;
  }
    this.InitializeForms();
    this.loadContractorInfoForm();
    this.checkContractorAllowManual();
    const taskitems = this.taskBuildingPermit.approvalTaskItems;
    const bids = taskitems.filter(
      x => x.name === 'Estimate' && x.payloadTypeCode === 700000001
    );
    bids.forEach(bid => {
      if (bid.statusCode === 700000002) {
        this.bid1rejected = true;
        this.bid1rejectedwhy = bid.reasonWhy;
      }
    });
    if (bids.filter(x => x.statusCode === 700000002).length > 0) {
    }
    this.trainingUrl = this.application.programType === 700000003 ? 
      this.xSiteNavigationService.essSiteUrl('/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser) :
      this.xSiteNavigationService.ebbSiteUrl('/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser);
      this.showesstraining =this.application.programType === 700000003 ? true :false;
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }
  private InitializeForms(): void {
    // Contractor info
    this.formContractorInfo = this.fb.group({
      contractorType: '',
      contractorInvitation: ''
    });
  }

  isAuthorizedAndRequiredBid(): boolean {
    return (
      this.checkUploadAuthorization() === 3 &&
      this.application.programCycle.bidMustSubmitDoc === true
    );
  }
  
  isAuthorizedAndRequiredEngineeredBid(): boolean {
    return (
      this.checkUploadAuthorization() === 3 &&
      this.application.programCycle.engineeredBidMustSubmitDoc === true
    );
  }
  
  get isSecondBidVisible(): boolean {
    return this.displaySecondBid !== false;
  }
  
  get isSecondBidEditMode(): boolean {
    return this.displaySecondBidLabel === 'EDIT';
  }
  

  
  
  // 1: no permissions;
  // 2: Contractor Review only
  // 3: ALL Edit;
  public checkUploadAuthorization(): number {
    const retVal = 3;
    //contractor is always read-only
    if (this.isContractor()) {
      return 1;
    }

    // submitted (preliminary review) - read only
    if (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true &&
        this.application.applicationStatusOptionSet !== 'Preliminary Review Rejected') {
      return 2;
    }

    // submitted (post-retrofit) - read only
    if (((this.application.stageCode === 700000001 &&
        this.application.eventApplicationSubmitted === true &&
        this.application.applicationStatusOptionSet !== 'Pending Approval') ||
        this.application.eventMitigationReviewSubmitted ||
        this.application.eventFinancialReviewSubmitted) &&
        (
          (this.application.contractorPermissionsCode !== 700000000 && this.utilityService.bidRequirementsMet(this.application, null, null, null,this.estimatemax)) ||
          this.application.contractorTypeCode !== 700000000
        )
    ) {
      return 2;
    }

    //mitigation review - read only
    if (
      this.application.stageCode === 700000003 &&
      this.application.eventApplicationSubmitted === true &&
      this.application.eventFinancialReviewSubmitted === true
    ) {
      return 2;
    }

    return retVal;
  }

  /**********************************************
   * Contractor
   */
  private loadContractorInfoForm(): void {
    if (this.application.contractorTypeCode > 0) {
      this.taskRetrofitContractorStatus = 'Selected';
      this.checkContractorAllowManual();
      // 700000000: Contractor; 700000001: Owner
      if (parseInt(this.application.contractorTypeCode.toString(), 10) === 700000000) {
        if (this.application._Ebb_ContractorId && this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId) {
          this.loadContractorData(this.application._Ebb_ContractorId);
          this.apiApplicationBid
            .getApplicationBidList(this.application.id)
            .subscribe(applicationBids => {
              // Get only the bids submitted by the homeowner
              applicationBids = applicationBids.filter(bid => bid.howSubmitted === 700000001 && (bid.bidType === null || bid.bidType === 700000000));
              this.bids = applicationBids;
              // Get only the bids submitted for the selected contractor
              const applicationBidsForSelectedContractor: IApplicationBid[] = applicationBids.filter(
                bid =>
                  bid._Ebb_ContractorId === this.application._Ebb_ContractorId
              );

              // If the selected contractor has no bids (e.g. this is a newly selected contractor)
              if (
                applicationBidsForSelectedContractor.length < 1 &&
                (this.application.contractorBidAmount1 != null ||
                  this.application.contractorBidAmount1Selected != null ||
                  this.application.contractorBidAmount2 != null ||
                  this.application.contractorBidReason != null)
              ) {
                // Update application; set bid data to null
                const appInput: IApplicationInput = {} as IApplicationInput;
                appInput.contractorBidAmount1 = null;
                appInput.contractorBidAmount1Selected = null;
                appInput.contractorBidAmount2 = null;
                appInput.contractorBidReason = null;
               if(this.application.stateCode ==0 && this.application.statusCode !== 700000018){
               

                
                const events = [this.apiApplication.updateApplication(appInput, this.application.id)];
                events.push(this.deleteBids(this.application.id));

                forkJoin(events)
                  .pipe(defaultIfEmpty(null))
                  .subscribe(
                    () => {
                      this.emitContractorUpdateEvent.emit(appInput);
                    },
                    error => console.error(`ERROR: deleting application bid amounts - ${error}`)
                  );
                
                }
                // Because we have no bids for selected contractor, set the display options accordingly
                this.setBidDisplayOptions(0, false);
              } else {
                // Display second bid button in either of the following conditions.
                // 1) More than one bid exists.
                // 2) Only one bid exists AND its amount is > $10k AND multiple bids are required.
                const firstBid = applicationBids[0];
                const secondBid = applicationBids[1];
                const waitingForContractorEstimate =
                  applicationBids.length === 1 &&
                  firstBid.amount > this.estimatemax &&
                  this.application.programCycle.multipleBidsRequired !== null &&
                  this.application.programCycle.multipleBidsRequired === true;

                if (this.application.applicationStatus !== 700000004 &&
                  applicationBids.length > 0 &&
                  firstBid !== undefined &&
                  firstBid !== null &&
                  firstBid.amount !== undefined &&
                  firstBid.amount !== null) {
                  const appInput: IApplicationInput = {} as IApplicationInput;
                  appInput.contractorBidAmount1 = firstBid.amount;
                  appInput.contractorBidAmount1Selected = firstBid.selected === 'true' ? true : false;

                  appInput.contractorBidReason =
                   (applicationBids.length > 1 &&
                     appInput.contractorBidAmount1Selected === true &&
                     appInput.contractorBidAmount1 > this.estimatemax &&
                     appInput.contractorBidAmount1 > secondBid.amount &&
                     firstBid.reason !== null &&
                     firstBid.reason !== undefined) ||
                    (applicationBids.length > 1 &&
                      appInput.contractorBidAmount1Selected === false &&
                      secondBid.amount > appInput.contractorBidAmount1 &&
                      secondBid.reason !== null &&
                      secondBid.reason !== undefined) ||
                    applicationBids.length === 1 && firstBid.reason !== null && firstBid.reason !== undefined
                  ? true
                  : false;
                  if(this.oktoeditapplication() && appInput !== undefined){
                    
                  const events = [this.apiApplication.updateApplication(appInput, this.application.id)];

                  forkJoin(events)
                    .pipe(defaultIfEmpty(null))
                    .subscribe(
                      () => {
                        //
                      },
                      error => console.error(`ERROR: Updating application bid amount on application - ${error}`)
                    );
                    
                  }
                }

                this.setBidDisplayOptions(
                  applicationBids.length,
                  applicationBids.length <= 1
                    ? waitingForContractorEstimate
                      ? true
                      : false
                    : true
                );

                // If we have two bids, then we need to evaluate:
                // 1) whether the selected bid needs a reason
                // 2) Whether the other bid needs to be deleted
                if (applicationBids.length === 2) {
                  const bidFirst: IApplicationBid =
                    applicationBids[0].isFirstBid === 'true'
                      ? applicationBids[0]
                      : applicationBids[1];
                  const bidSecond: IApplicationBid =
                    applicationBids[0].isFirstBid === 'true'
                      ? applicationBids[1]
                      : applicationBids[0];
                  // If 1st bid is selected, perform further evaluation of bids
                  if (
                    bidFirst.selected === 'true' &&
                    this.application.contractorBidAmount1Selected === true
                  ) {
                    // If 1st bid amount is > $10,000
                    if (bidFirst.amount > this.estimatemax) {
                      // If 1st bid amount is > 2nd bid amount and no reason has been submitted for 1st bid
                      if (bidFirst.amount > bidSecond.amount && (bidFirst.reason === null || bidFirst.reason.length < 1)) {
                        // Reason is required; make the user submit a reason
                        this.showSubmitBid(
                          '1stBid',
                          bidFirst._Ebb_ContractorId,
                          bidFirst._Ebb_ContractorId_Formatted,
                          true
                        );
                      }
                    } else {
                      // Delete the 2nd bid (because 1st bid is <= $10,000).
                      this.apiApplicationBid
                        .delete({
                          id: bidSecond.id,
                          _Ebb_ApplicationId: bidSecond._Ebb_ApplicationId
                        } as IApplicationBidInput)
                        .subscribe(
                          res => console.log('2nd bid deleted'),
                          err => console.log('error deleting 2nd bid'),
                          () => console.log('2nd bid deletion attempt finished')
                        );
                      this.setBidDisplayOptions(1, false);
                    }
                  } else {
                    // Because 1st bid is not selected, assume 2nd bid is selected...
                    if (bidSecond.amount <= this.estimatemax) {
                      // Delete the 1st bid (because 2nd bid is <= $10,000 and is selected).
                      this.apiApplicationBid
                        .delete({
                          id: bidFirst.id,
                          _Ebb_ApplicationId: bidFirst._Ebb_ApplicationId
                        } as IApplicationBidInput)
                        .subscribe(
                          res => {
                            console.log('1st bid deleted');
                            // Update the value of the remaining bid to 'first bid = yes'
                            this.apiApplicationBid
                              .update({
                                id: bidSecond.id,
                                _Ebb_ApplicationId:
                                  bidSecond._Ebb_ApplicationId,
                                  bidType:700000000,
                                isFirstBid: 'true'
                              } as IApplicationBidInput)
                              .subscribe(
                                res =>
                                  console.log('2nd bid updated as 1st bid'),
                                err =>
                                  console.log(
                                    'error updating 2nd bid as 1st bid'
                                  ),
                                () =>
                                  console.log(
                                    '2nd bid update (to 1st bid) attempt finished'
                                  )
                              );
                          },
                          err => console.log('error deleting 1st bid'),
                          () => console.log('1st bid deletion attempt finished')
                        );
                      const appInput: IApplicationInput = {} as IApplicationInput;
                      appInput.contractorBidAmount1 = parseFloat(bidSecond.amount.toString());
                      appInput.contractorBidAmount1Selected = true;
                      appInput.contractorBidAmount2 = null;
                      appInput.contractorBidReason = null;
                      this.apiApplication
                        .updateApplication(appInput, this.application.id)
                        .subscribe(
                          res =>
                            console.log('Finished application bid amounts'),
                          err =>
                            console.error(
                              'ERROR: updating application bid amounts'
                            )
                        );
                      this.setBidDisplayOptions(1, false);
                    } else {
                      // If 2nd bid amount is > 1st bid amount and no reason has been submitted for 2nd bid
                      if (bidSecond.amount > bidFirst.amount &&
                        (bidSecond.reason === null ||
                          bidSecond.reason.length < 1)
                      ) {
                        // Reason is required; make the user submit a reason
                        this.showSubmitBid(
                          '2ndBidEdit',
                          bidSecond._Ebb_ContractorId,
                          bidSecond._Ebb_ContractorId_Formatted,
                          true
                        );
                      }
                    }
                  }
                }
              }
            });
        }
        this.selectRetrofitContractor = 700000000;
      } else {
        this.selectRetrofitContractor = 700000001;
      }
    } else {
      this.selectRetrofitContractor = 0;
    }

    if (
      parseInt(this.application.contractorPermissionsCode.toString(), 10) ===
      700000001
    ) {
      this.taskRetrofitContractorGrantPerm = 700000001;
    } else if (
      parseInt(this.application.contractorPermissionsCode.toString(), 10) ===
      700000002
    ) {
      this.taskRetrofitContractorGrantPerm = 700000002;
    } else {
      this.taskRetrofitContractorGrantPerm = 700000000;
    }
  }
  private oktoeditapplication():boolean{
var oktoedit = true;
    if ((
      this.application.applicationStatus === 700000009
   || this.application.applicationStatus == 700000005
   || this.application.applicationStatus == 700000012
   || this.application.applicationStatus == 700000010
   || this.application.applicationStatus == 700000016
   || this.application.applicationStatus == 700000004
   || this.application.applicationStatus == 700000006 
   || this.application.applicationStatus == 700000018
   )
   && (this.isContractor() || this.isHomeowner()))
{
  oktoedit= false;
}
if(this.application.stateCode ==1 ){
  oktoedit= false;

}

    return oktoedit;
  }
  private loadContractorData(id: string): void {
    this.apiContractor.getContractor(id, true).subscribe(
      contractor => {
        this.retrofitContractor = contractor;
        if (this.retrofitContractor.fullName) {
          this.taskRetrofitContractorSummary = this.retrofitContractor.fullName;
        }
      },
      error => console.warn(error)
    );
  }

  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  public onChangeEventContractor(event: MatRadioChange): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    this.formAutoSave = true;
    applicationInput.contractorTypeCode = parseInt(event.value, 10);
    applicationInput.contractorPermissionsCode = 700000000;
    applicationInput.contractorInvitationCode = 700000000;
    if(this.oktoeditapplication() && applicationInput !== undefined){
   
    const events = [];

    if (parseInt(applicationInput.contractorTypeCode.toString(), 10) === 700000001) {
      applicationInput._Ebb_ContractorId = this.application._Ebb_OwnerId;
      this.application._Ebb_ContractorId = this.application._Ebb_OwnerId;  
      applicationInput.contractorTypeCode =700000001;
      this.application.contractorTypeCode=700000001;
      this.deleteBids(this.application.id).subscribe();
      // events.push(this.deleteBids(this.application.id));
      // events.push(this.apiApplication.updateApplication(applicationInput, this.application.id))
    }else{
     // events.push(this.apiApplication.updateApplication(applicationInput, this.application.id))
    }
    this.apiApplication.updateApplication(applicationInput, this.application.id) .subscribe(
      data => {
        this.emitContractorUpdateEvent.emit(applicationInput);
        this.checkContractorAllowManual();
        this.loadContractorInfoForm();
      },
      error => console.warn(`ERROR: onChangeEventContractor() - ${error}`)
    );
    // forkJoin(events)
    //   .pipe(defaultIfEmpty(null))
    //   .subscribe(
    //     () => {
    //       this.formAutoSave = false;
    //       this.selectRetrofitContractor = event.value;
    //       this.emitContractorUpdateEvent.emit(applicationInput);
    //     //  this.emitContractorFileUploadEvent.emit(this.taskBuildingPermit);
    //       this.checkContractorAllowManual();
    //       this.loadContractorInfoForm();
    //     },
    //     error => console.warn(`ERROR: onChangeEventContractor() - ${error}`)
    //   );
      }
    
  }

  public onChangeEventContractorSwitch(code: number): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    this.formAutoSave = true;
    applicationInput.contractorTypeCode = code;

    const events = [];
    if(this.oktoeditapplication() && applicationInput !== undefined){
      
    if (code === 700000001) {
      applicationInput._Ebb_ContractorId = this.application._Ebb_OwnerId;
      this.application._Ebb_ContractorId = this.application._Ebb_OwnerId;
      applicationInput.contractorTypeCode =700000001;
      this.application.contractorTypeCode=700000001;
  
      this.deleteBids(this.application.id).subscribe();
      // events.push(this.deleteBids(this.application.id));
      // events.push(this.apiApplication.updateApplication(applicationInput, this.application.id));
     
    } else {
      
   //   events.push(this.apiApplication.updateApplication(applicationInput, this.application.id));
    }
    this.apiApplication.updateApplication(applicationInput, this.application.id) .subscribe(
      data => {
        this.emitContractorUpdateEvent.emit(applicationInput);
        this.checkContractorAllowManual();
        this.loadContractorInfoForm();
      },
      error => console.warn(`ERROR: onChangeEventContractorSwitch() - ${error}`)
    );
    // forkJoin(events)
    //   .pipe(defaultIfEmpty(null))
    //   .subscribe(
    //     () => {
    //       this.formAutoSave = false;
    //       code === 700000000
    //         ? (this.selectRetrofitContractor = 700000000)
    //         : (this.selectRetrofitContractor = 700000001);
    //       this.emitContractorUpdateEvent.emit(applicationInput);
    //      // this.emitContractorFileUploadEvent.emit(this.taskBuildingPermit);
    //       this.checkContractorAllowManual();
    //       this.loadContractorInfoForm();
       
    //     },
    //     error =>
    //       console.warn(`ERROR: onChangeEventContractorSwitch() - ${error}`)
    //   );
      
    }
  }

  public onClickManageContractorPermission(perm: number, programType: number): void {
    if (parseInt(perm.toString(), 10) === 700000001) {
      const dialogRef = this.dialogPermission.open(DialogPermissionComponent, {
        width: '400px',
        disableClose: false,
        data: { programType: programType }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.updateContractorPermission(parseInt(result.toString(), 10));
        }
      });
    } else if (parseInt(perm.toString(), 10) === 700000002) {
      this.updateContractorPermission(700000002);
    } else {
      this.updateContractorPermission(700000000);
    }
  }

  private updateContractorPermission(codeValue: number): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    applicationInput.contractorPermissionsCode = codeValue;

    if(this.application.contractorInvitationCode !== 700000002 ){
    if (parseInt(codeValue.toString(), 10) === 700000001) {
      if(this.application.contractorInvitationCode !== 700000001){
        applicationInput.contractorInvitationCode = 700000001;
      }
      if(this.application.contractorInvitationDate === null) {
      
      applicationInput.contractorInvitationDate = this.currentDate;}
      this.formContractorInfo.get('contractorInvitation').setValue('700000001');
    } else if (parseInt(codeValue.toString(), 10) === 700000002) {
      if(this.application.contractorInvitationCode !== 700000001){
        applicationInput.contractorInvitationCode = 700000001;
      }
      if(this.application.contractorInvitationDate === null) {
      
      applicationInput.contractorInvitationDate = this.currentDate;}
      this.formContractorInfo.get('contractorInvitation').setValue('700000002');
    } else {
      applicationInput.contractorInvitationCode = 700000000;
      applicationInput.contractorInvitationDate = null;
      this.formContractorInfo.get('contractorInvitation').setValue('700000000');
    }
  }
    this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        data => {
          this.emitContractorUpdateEvent.emit(applicationInput);
          this.loadContractorInfoForm();
        },
        error => console.warn(`ERROR: updateContractorPermission() - ${error}`)
      );
  }

  public onSubmitBidEvent(firstOrSecond: string): void {
    if (firstOrSecond === '2ndBid') {
      this.onOpenDirectoryEvent(firstOrSecond);
    } else {
      this.showSubmitBid(firstOrSecond, '', '', false);
    }
  }
 

  private showSubmitBid(
    firstOrSecond: string,
    bidContractorId: string,
    bidContractorName: string,
    reasonRequired: boolean
  ): void {
    const thisContext = this;

    this.apiApplicationBid
      .getApplicationBidList(this.application.id)
      .subscribe(applicationBids => {
        applicationBids = this.filterContractorBids(applicationBids);
        ({ applicationBids, reasonRequired } = this.Contractorbids(applicationBids, firstOrSecond, bidContractorName, bidContractorId, reasonRequired, thisContext));
      });
  }


  
  private Contractorbids(applicationBids: IApplicationBid[], firstOrSecond: string, bidContractorName: string, bidContractorId: string, reasonRequired: boolean, thisContext: this) {
    let bid1: IApplicationBid = null;
    let bid2: IApplicationBid = null;
    let dialogUploadDataItem: DialogUploadApplicationBidData;

    

    // If any bids already exist, identify which one is the first bid and which one is the second bid
    if (applicationBids && applicationBids.length > 0) {
      // If we're replacing the second bid (i.e. selecting a new contractor)
      if (firstOrSecond === '2ndBid' && applicationBids.length > 1) {
        const bidsToDelete = applicationBids.filter(
          bid => bid.isFirstBid === 'false'
        );
        // Delete the existing 2nd bid from the server.
        this.deleteBid(
          bidsToDelete[0].id,
          bidsToDelete[0]._Ebb_ApplicationId
        ).subscribe();
        // Remove the existing 2nd bid from the client array.
        applicationBids = applicationBids.filter(
          bid => bid.isFirstBid === 'true'
        );
      }

      // For now, assume we are successful in keeping the list to two (2) bids max, and assume that only one has cea_isfirstbid = yes.
      const bidA = applicationBids[0];
      const bidB = applicationBids.length > 1 ? applicationBids[1] : null;
      bid1 = bidA.isFirstBid === 'true' ? bidA : bidB;
      bid2 = bidA.isFirstBid === 'true' ? bidB : bidA;
      // Save bids for later retrieval in other contexts (e.g. SafeSubscriber)
      ContractorFormComponent.prototype.setBids(bid1, bid2);
    }

    if (applicationBids && applicationBids.length > 2) {
      console.error('applicationBids.length=' + applicationBids.length);
    } else {
      let attachmentName: string = null;
      let contractorId: string = null;
      let contractorId2: string = null;
      let contractorName: string = null;
      let payload: string = null;
      let payloadName: string = null;
      let reason: string = null;

      attachmentName =
        firstOrSecond === '2ndBid'
          ? bidContractorName
          : this.retrofitContractor.businessName;
      contractorId =
        firstOrSecond === '2ndBid'
          ? bidContractorId
          : this.retrofitContractor.id;

    
      // If there is no first bid (bid1 is null) and this is the first bid scenario
if (bid1 === null && firstOrSecond === '1stBid') {
  // Assign the retrofit contractor's business name and ID
  attachmentName = this.retrofitContractor.businessName;
  contractorId = this.retrofitContractor.id;
} else if (bid1 !== null && firstOrSecond === '1stBid') { // If the first bid exists and this is the first bid scenario
  // Extract the contractor name from bid1's name and assign the contractor ID
  attachmentName = bid1.name.substr(bid1.name.indexOf('from') + 5);
  contractorId = bid1._Ebb_ContractorId;
  
  // Check if bid1 has payload data
  if (bid1.payload !== null) {
      payload = bid1.payload;
      payloadName = bid1.payloadName;
  } else { // If no payload exists, set both payload and payloadName to null
      bid1.payload = null;
      bid1.payloadName = null;
  }

  // Check if the first bid is selected and other conditions to determine if a reason is required
  if (
      bid1.selected === 'true' && // The first bid is marked as selected
      bid2 !== null && // The second bid exists
      bid2.amount !== null && // The second bid has an amount
      bid1.amount > this.estimatemax && // The first bid exceeds the estimate max
      bid1.amount > bid2.amount && // The first bid amount is greater than the second bid amount
      (bid1.reason === null || bid1.reason.length < 1) // No valid reason provided for selecting the first bid
  ) {
      reasonRequired = true; // A reason is required for selecting this bid
  }

  // Assign the reason if it exists and has a valid length, otherwise set it to null
  reason = bid1.reason && bid1.reason.length > 0 ? bid1.reason : null;
} else if (firstOrSecond === '2ndBid' || firstOrSecond === '2ndBidEdit') { // If this is a second bid scenario
  // Determine the attachment name based on the scenario
  attachmentName =
      firstOrSecond === '2ndBid'
          ? bidContractorName // For new second bid, use bidContractorName
          : firstOrSecond === '2ndBidEdit'
              ? bid2.name.substr(bid2.name.indexOf('from') + 5) // For editing, extract contractor name from bid2
              : attachmentName; // Otherwise, keep the current attachment name

  // Assign contractor IDs for bid1 and bid2 based on the scenario
  contractorId =
      bid1 !== null ? bid1._Ebb_ContractorId : bidContractorId; // Use bid1 contractor ID if available, otherwise use bidContractorId
  contractorId2 =
      firstOrSecond === '2ndBid'
          ? bidContractorId // For new second bid, use bidContractorId
          : bid2._Ebb_ContractorId; // For editing, use bid2 contractor ID

  // Check if bid2 has payload data
  if (bid2 !== null && bid2.payload !== null) {
      payload = bid2.payload; // Assign the payload data from bid2
      payloadName = bid2.payloadName; // Assign the payload name from bid2
  }
}



      contractorName = attachmentName;

      dialogUploadDataItem = {
        isImage: false,
        attachmentName: attachmentName,
        contractorName: contractorName,
        contractorId: contractorId,
        contractorId2: contractorId2,
        applicationId: this.application.id,
        ownerId: this.application._Ebb_OwnerId,
        ownerIdFormatted: this.application._Ebb_OwnerId_Formatted,
        firstOrSecond: firstOrSecond,
        isSelected: false,
        reasonRequired: reasonRequired &&
          this.application.programCycle.multipleBidsRequired &&
          this.application.programCycle.multipleBidsRequired === true,
        reason: reason,
        payload: payload,
        payloadName: payloadName,
        multipleBidsRequired: this.application.programCycle.multipleBidsRequired &&
          this.application.programCycle.multipleBidsRequired === true
      } as DialogUploadApplicationBidData;

      // For existing bids, populate id and other existing values, to make the request an update instead of an insert
      let bidAm1: number = null;
      let bidAm2: number = null;
      if (bid1 !== null && firstOrSecond === '1stBid') {
        dialogUploadDataItem.id = bid1.id;
        dialogUploadDataItem.isSelected =
          bid1.selected === 'true' ? true : false;
        bidAm1 = bid1.amount;
        dialogUploadDataItem.reason = bid1.reason;
        if (bid2 === null) {
          bidAm2 = 0;
          dialogUploadDataItem.isSelected2 = false;
          dialogUploadDataItem.contractorId2 = '';
          dialogUploadDataItem.reason2 = null;
        } else {
          bidAm2 = bid2.amount;
          dialogUploadDataItem.contractorId2 = bid2._Ebb_ContractorId;
          dialogUploadDataItem.bidId2 = bid2.id;
          dialogUploadDataItem.isSelected2 =
            bid2.selected === 'true' ? true : false;
          dialogUploadDataItem.reason2 = bid2.reason;
        }
      } else {
        if (firstOrSecond === '2ndBid' || firstOrSecond === '2ndBidEdit') {
          dialogUploadDataItem.id = bid1.id;
          dialogUploadDataItem.isSelected =
            bid1.selected === 'true' ? true : false;
          bidAm1 = bid1.amount;
          dialogUploadDataItem.reason = bid1.reason;
          if (bid2 === null) {
            bidAm2 = 0;
            dialogUploadDataItem.contractorId2 = bidContractorId;
            dialogUploadDataItem.bidId2 = '';
            dialogUploadDataItem.isSelected2 = false;
            dialogUploadDataItem.reason2 = null;
          } else {
            bidAm2 = bid2.amount;
            dialogUploadDataItem.contractorId2 =
              firstOrSecond === '2ndBid'
                ? bidContractorId
                : dialogUploadDataItem.contractorId2;
            dialogUploadDataItem.bidId2 = bid2.id;
            dialogUploadDataItem.isSelected2 =
              bid2.selected === 'true' ? true : false;
            dialogUploadDataItem.reason2 = bid2.reason;
          }
        }
      }
      dialogUploadDataItem.estimatedCost = bidAm1;
      dialogUploadDataItem.estimatedCost2 = bidAm2;
      dialogUploadDataItem.estimatemax = this.estimatemax;
      const dialogRef = this.dialogUpload.open(
        DialogUploadApplicationBidComponent,
        {
          width: '650px',
          height: '650px',
          data: dialogUploadDataItem
        }
      );

      dialogRef.afterClosed().subscribe(async (bidUploadResult) => {
        if (bidUploadResult &&
          ((bidUploadResult.payload !== undefined &&
            bidUploadResult.payload !== null &&
            bidUploadResult.payload.length > 0) ||
            (bidUploadResult.uploadFile !== undefined &&
              bidUploadResult.uploadFile !== null))) {
          this.saveBidProgressIndicator = true;
          // If user has chosen to change the contractor on the 2nd bid, then restart the 2nd bid process from the point of selecting the contractor.
          if (bidUploadResult.contractorId2 !== null &&
            bidUploadResult.contractorId2 === 'CHANGE') {
            this.onOpenDirectoryEvent('2ndBid');
          } else {
            // Check the bid amount. If > $10,000 AND multiple bids are required, then allow a second bid to be submitted
            if (bidUploadResult.estimatedCost > this.estimatemax) {
              const secondBidRequired: boolean = this.application.programCycle.multipleBidsRequired &&
                this.application.programCycle.multipleBidsRequired === true;
              if (bidUploadResult.estimatedCost2 !== null &&
                bidUploadResult.estimatedCost2 > 0) {
                // Two existing bids and first is > 10k, conditionally display second bid
                this.setBidDisplayOptions(2, secondBidRequired);
              } else {
                // Only one existing bid and it's > 10k, conditionally display second bid
                this.setBidDisplayOptions(1, secondBidRequired);
              }
            } else {
              if (bidUploadResult.estimatedCost2 !== null &&
                bidUploadResult.estimatedCost2 > 0) {
                // Two existing bids, so display second bid
                this.setBidDisplayOptions(2, true);
              } else {
                // One bid exists and it's <= 10k, so do not display second bid
                this.setBidDisplayOptions(1, false);
              }
            }

            // After the "Upload bid" dialog is closed, save the Application Bid.
            // Because the context switches within different subscriptions, save the result in the ContractorFormComponent context, to be accessed later.
            ContractorFormComponent.prototype.setBidUploadResult(
              bidUploadResult
            );
            //TODO: move all of the 'ContractorFormComponent.prototype' calls (e.g. previous line) into the 'thisContext' (const) context.
            thisContext.bidUploadResultContext = bidUploadResult;

            // tslint:disable-next-line: prefer-const
            let dateSentNow = new Date();
            dateSentNow.setHours(dateSentNow.getHours() + 7);

            let applicationBidInput: IApplicationBidInput;

            applicationBidInput = {
              amount: bidUploadResult.firstOrSecond === '1stBid'
                ? parseFloat(bidUploadResult.estimatedCost)
                : parseFloat(bidUploadResult.estimatedCost2),
              name: `${this.application._Ebb_OwnerId_Formatted} submitted bid from ${bidUploadResult.contractorName}`,
              _Ebb_ApplicationId: bidUploadResult.applicationId,
              _Ebb_OwnerId: bidUploadResult.ownerId,
              _Ebb_ContractorId: bidUploadResult.firstOrSecond === '1stBid'
                ? bidUploadResult.contractorId
                : bidUploadResult.contractorId2,
              selected: bidUploadResult.firstOrSecond === '1stBid' &&
                bidUploadResult.isSelected === true
                ? 'true'
                : (bidUploadResult.firstOrSecond === '2ndBid' ||
                  bidUploadResult.firstOrSecond === '2ndBidEdit') &&
                  bidUploadResult.isSelected2 === true
                  ? 'true'
                  : 'false',
              dateSent: dateSentNow,
              isFirstBid: bidUploadResult.firstOrSecond === '1stBid'
                ? 'true'
                : 'false',
              howSubmitted: 700000001,
              bidType: 700000000,
              reason: bidUploadResult.firstOrSecond === '1stBid'
                ? bidUploadResult.reason
                : bidUploadResult.reason2
            } as IApplicationBidInput;

            // If an id was passed through the upload dialog, pass it along with the applicationBidInput, making sure an update is attempted.
            if (!isNull(bidUploadResult.id) &&
              bidUploadResult.firstOrSecond !== '2ndBid' &&
              bidUploadResult.firstOrSecond !== '2ndBidEdit') {
              applicationBidInput.id = bidUploadResult.id;
            } else {
              if (!isNull(bidUploadResult.bidId2) &&
                bidUploadResult.bidId2 !== '' &&
                (bidUploadResult.firstOrSecond === '2ndBid' ||
                  bidUploadResult.firstOrSecond === '2ndBidEdit')) {
                applicationBidInput.id = bidUploadResult.bidId2;
              }
            }

            this.apiApplicationBid.update(applicationBidInput).subscribe(
              async (applicationBidId) => {
                if (applicationBidId) {
                  // Application Bid is saved. Now,add Annotation
                  //console.log('application bid update finished');
                  const savedApplicationBidId = applicationBidId;

                  if (thisContext.bidUploadResultContext.uploadFileName &&
                    thisContext.bidUploadResultContext.uploadFileName
                      .length > 0) {
                    // Context has switched to the subscription context. Now, get upload file data from the ContractorFormComponent context.
                    const savedBidUploadResult = ContractorFormComponent.prototype.getBidUploadResult();
                    const uploadFileName = savedBidUploadResult.uploadFileName.replace(/[;,/?:@&=+$]/g, '');

                    blobToBase64String(
                      savedBidUploadResult.uploadFile
                    ).then(base64string => {
                      const fileString64 = base64string;
                      const annotationInput: IAnnotationInput = {
                        id: null,
                        _Objectid_Value: applicationBidId,
                        objectTypeCode: 'cea_applicationbid',
                        fileName: uploadFileName,
                        fileSize: savedBidUploadResult.uploadFile.size,
                        mimeType: savedBidUploadResult.uploadFile.type,
                        subject: uploadFileName,
                        noteText: savedBidUploadResult.dateSent,
                        documentBody: fileString64
                      };

                      //console.log('saveAnnotation');
                      this.apiAnnotation
                        .saveAnnotation(annotationInput)
                        .subscribe(
                          annotation => {
                            //console.log('saveAnnotation has finished');
                            // Now that the bid and annotation have been saved, link them together.
                            const applicationBidInputForAnnotation = {
                              id: savedApplicationBidId,
                              _Ebb_ApplicationId: savedBidUploadResult.applicationId,
                              payload: annotation.id,
                              payloadName: uploadFileName
                            } as IApplicationBidInput;

                            this.apiApplicationBid
                              .update(applicationBidInputForAnnotation)
                              .subscribe(
                                appBidId => {
                                  if (appBidId) {
                                    //console.log('application bid updated with annotation data')
                                  }
                                  thisContext.updateAppAndBid(
                                    thisContext,
                                    dateSentNow
                                  );
                                },
                                error => console.error(error)
                              );
                          },
                          error => console.error(error)
                        );
                    });
                  } else {
                    if (bidUploadResult.payload !== undefined &&
                      bidUploadResult.payload !== null &&
                      bidUploadResult.payload.length > 0) {
                      await thisContext.updateAppAndBid(thisContext, dateSentNow);
                    }
                  }
                  const applicationbids = this.bids.filter(x => x.id === applicationBidId);
                  if (applicationbids.length > 0) {
                    const bid = applicationbids[0];
                    if (bid._Ebb_ApprovalTaskItemId) {
                      const taskitem = this.taskBuildingPermit.approvalTaskItems.find(x => x.id === bid._Ebb_ApprovalTaskItemId);
                      const index = this.taskBuildingPermit.approvalTaskItems.findIndex(i => i.id === taskitem.id);
                      if (taskitem && taskitem.id) {
                        this.apiApprovalTaskItem.getItem(taskitem.id).subscribe(data => {
                          this.taskBuildingPermit.approvalTaskItems[index] = cloneDeep(data as IApprovalTaskItem);

                          this.taskBuildingPermit.approvalTaskItems[index].statusCode = 700000003;
                          this.bid1rejected = false;
                          // this.emitContractorFileUploadEvent.emit(this.taskBuildingPermit);
                          thisContext.loadContractorInfoForm();
                        });
                      }
                    }
                    else {
                      this.emitContractorFileUploadEvent.emit(this.taskBuildingPermit);
                      thisContext.loadContractorInfoForm();
                    }

                  }


                }
              },
              error => console.error(error)
            );
          }
        } else {
          thisContext.loadContractorInfoForm();
        }
      });
    }
    return { applicationBids, reasonRequired };
  }

  private filterContractorBids(applicationBids: IApplicationBid[]) {
    applicationBids = applicationBids.filter(
      bid => bid.howSubmitted === 700000001 && (bid.bidType === 700000000 || bid.bidType === null)
    );
    return applicationBids;
  }

  
  
  public async updateAppAndBid(thisContext, dateSentNow: Date): Promise<void> {
    // At this point, this bid/annotation has been submitted. Now, update the application with bid amounts from any submitted bids.
    const applicationInput: IApplicationInput = {} as IApplicationInput;

    let estimate2 =0;
    if (this.bidUploadResultContext.estimatedCost2) {
      // tslint:disable-next-line:radix
      estimate2 = Number.parseInt(this.bidUploadResultContext.estimatedCost2);
    }

    // tslint:disable-next-line:radix
    const estimate1 =  Number.parseInt(this.bidUploadResultContext.estimatedCost);
      // tslint:disable-next-line:radix
      if (this.bidUploadResultContext.isSelected2 && estimate2 < this.estimatemax) {
        applicationInput.contractorBidAmount1 = 0;
      } else {
        applicationInput.contractorBidAmount1 = parseFloat(estimate1.toString());
      }
    let applicationbids: IApplicationBid[];
    if (this.bidUploadResultContext.isSelected2 === true) {
      applicationbids = this.bids.filter(x => x.id === thisContext.bidUploadResultContext.id);

    } else if (this.bidUploadResultContext.isSelected === true) {
      applicationbids = this.bids.filter(x => x.id === thisContext.bidUploadResultContext.bidId2);

    }
    if (applicationbids.length > 0) {
      const bid = applicationbids[0];
      if (bid._Ebb_ApprovalTaskItemId) {
        for (let i = 0; i < this.taskBuildingPermit.approvalTaskItems.length; i++) {
          const obj = this.taskBuildingPermit.approvalTaskItems[i];

          if (obj.id === bid._Ebb_ApprovalTaskItemId) {
            this.taskBuildingPermit.approvalTaskItems.splice(i, 1);
          }
        }

      }
      this.bid1rejected = false;
    }

          if ( this.bids.length>1 &&
            (thisContext.bidUploadResultContext.isSelected === true &&
              thisContext.bidUploadResultContext.estimatedCost2 !== null &&
              thisContext.bidUploadResultContext.estimatedCost2 !== 0) ||
            thisContext.bidUploadResultContext.isSelected2 === true
          ) {
            let bidIdToDeselect = '';
            if (thisContext.bidUploadResultContext.isSelected2 === true)
            {
               bidIdToDeselect = thisContext.bidUploadResultContext.id;
               thisContext.bidUploadResultContext.isSelected=false;

            } else {
               bidIdToDeselect = thisContext.bidUploadResultContext.bidId2;
            }

            // If we have a bid to deselect
            if (bidIdToDeselect !== '' ) {
              // Deselect the bid
              const applicationBidInput = { id: bidIdToDeselect, _Ebb_ApplicationId: thisContext.bidUploadResultContext.applicationId, selected: 'false', reason: '', dateSent: dateSentNow } as IApplicationBidInput;

              this.apiApplicationBid
                .update(applicationBidInput)
                .subscribe(applicationBidId => {
                  if (applicationBidId) {
                  } else {
                    console.warn(
                      'error during attempt to deselect bid'
                    );
                  }
                });
            }


          } else {
            console.warn('neither bid is selected, no need to deselect one');
          }

    let selectedContractorId = '';
    if (thisContext.bidUploadResultContext.isSelected === true) {
      selectedContractorId = thisContext.bidUploadResultContext.contractorId;
    } else {
      selectedContractorId = thisContext.bidUploadResultContext.contractorId2;
    }
    if (selectedContractorId !==
      thisContext.application._Ebb_ContractorId
    ) {

      applicationInput.contractorTypeCode = 700000000;
      applicationInput.contractorInvitationCode = 700000000;
      applicationInput.contractorPermissionsCode = 700000000;
      applicationInput.contractorInvitationDate = null;
      applicationInput._Ebb_ContractorId = selectedContractorId;
      thisContext.application._Ebb_ContractorId = selectedContractorId;
    }
    if (estimate2 > 0){ applicationInput.contractorBidAmount2 = parseInt(estimate2.toString(), 10);}
    applicationInput.contractorBidReason =
      this.bidUploadResultContext.reason !== undefined &&
        this.bidUploadResultContext.reason !== null &&
        this.bidUploadResultContext.reason.length > 0
        ? true
        : this.bidUploadResultContext.isSelected2 &&
          this.bidUploadResultContext.reason2 !== undefined &&
          this.bidUploadResultContext.reason2 !== null &&
          this.bidUploadResultContext.reason2.length > 0
          ? true
          : false;
    applicationInput.contractorBidAmount1Selected = this.bidUploadResultContext
      .isSelected
      ? true
      : false;

   await this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.emitContractorUpdateEvent.emit(applicationInput);
          thisContext.loadContractorInfoForm();
          this.emitContractorFileUploadEvent.emit(this.taskBuildingPermit);
          thisContext.saveBidProgressIndicator = false;
          thisContext.saveEngBidProgressIndicator= false;

        },
        error =>
          console.error(`ERROR: updating application bid amounts - ${error}`)
      );


  }

  public setBidUploadResult(bidUploadObject): void {
    this.bidUploadResult = bidUploadObject;
  }

  public getBidUploadResult() {
    return this.bidUploadResult;
  }

  public setBids(bid1, bid2): void {
    this.bid1 = bid1;
    this.bid2 = bid2;
  }

  public onOpenDirectoryEvent(
    openOption: 'default' | 'intro' | 'estimate' | '2ndBid' | '2ndBidEdit'
  ): void {
    const dwellingZip = this.application.name.split(' ').pop();
    const dwellingId = this.application._Ebb_DwellingId;
    this.showContractorDirectory(dwellingZip, dwellingId, openOption);
  }

  private showContractorDirectory(
    dwellingZip: string,
    dwellingId: string,
    openOption: 'default' | 'intro' | 'estimate' | '2ndBid' | '2ndBidEdit'
  ): void {
    ContractorFormComponent.prototype.setOpenOption(openOption);

    const sheetRef = this.infoSheet.open(AppSheetContractorComponent, {
      data: {
        appZIP: dwellingZip,
        dwellingId: dwellingId,
        openOption: openOption,
        application: this.application,
        isPortal: true
      }
    });

    sheetRef.afterDismissed().subscribe(contractorId => {
      if (contractorId && contractorId.length > 0) {
        const openOption = ContractorFormComponent.prototype.getOpenOption();
        if (openOption === '2ndBid' || openOption === '2ndBidEdit') {
          // populate this.bidContractorName for the bid
          this.apiContractor.getContractor(contractorId, false).subscribe(
            contractor => {
              // If we are coming from the 2ndBid dialog, instead of the contractor-form
              if (openOption === '2ndBidEdit') {
                //for now, just get the contractor selection sheet closed...
              } else {
                if (isNull(contractor)) {
                  this.showSubmitBid(
                    openOption,
                    contractorId,
                    'selected contractor',
                    false
                  );
                } else {
                  this.showSubmitBid(
                    openOption,
                    contractorId,
                    contractor.businessName,
                    false
                  );
                }
              }
            },
            error => console.warn(error)
          );
        } else {
          const applicationInput: IApplicationInput = {} as IApplicationInput;
          applicationInput.contractorTypeCode = 700000000;
          applicationInput.contractorPermissionsCode = 700000000;
          applicationInput.contractorInvitationCode = 700000000;
          applicationInput._Ebb_ContractorId = contractorId;
          this.apiApplication
            .updateApplication(applicationInput, this.application.id)
            .subscribe(
              () => {
                this.emitContractorUpdateEvent.emit(applicationInput);
                this.loadContractorInfoForm();
              },
              error =>
                console.warn(`ERROR: showContractorDirectory() - ${error}`)
            );
        }
      } else {
        console.warn(`Not return a result`);
      }
    });
  }

  public setOpenOption(openOption: string) {
    this.openOption = openOption;
  }

  public getOpenOption(): string {
    return this.openOption;
  }
  public isDoItMyselfVisible(): boolean {
    return this.application.programType !== 700000003 && this.application.programType !== 700000004;
  }
  
  public onContractorUnlistedEvent(): void {
    const dialogRef = this.dialogContractorUnlisted.open(
      DialogContractorUnlistedComponent,
      { panelClass: 'dialog-container-scroll' }
    );
    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          const isexists: Boolean = data.isexists as Boolean;
          const newContact: IContactInput = data.contactInput as IContactInput;
          if(!isexists){
          this.apiContact.saveContactUnlisted(newContact).subscribe(
            data => {
              const applicationInput: IApplicationInput = {} as IApplicationInput;
              const contractorId = data.id;
              applicationInput.contractorTypeCode = 700000000;
              applicationInput.contractorPermissionsCode = 700000000;
              applicationInput.contractorInvitationCode = 700000001;
              applicationInput._Ebb_ContractorId = contractorId;
              applicationInput.contractorPermissionsCode = 700000002;
              this.application._Ebb_ContractorId = contractorId;
              const con = new Date(data.createdOn);
              const today = new Date();
              today.setDate(today.getDate()-1);
              //console.log(`${con.getTime()} : ${today.getTime()}`)
              if(data.contractorManualEntry && con.getTime() < today.getTime())
              {
                  this.snackBar.open(`Your contractor already exists in our system, please check the information. Contact us if any updates are needed at (877) 232-4300 or info@crmp.org.`,'CONFIRM');
              }
              else if(data.contractorInDirectory)
              {
                  this.snackBar.open(`Your contractor already exists in our contractor directory, please check the information. Contact us if you have any questions at (877) 232-4300 or info@crmp.org.`,'CONFIRM');
              }
              this.apiApplication
                .updateApplication(applicationInput, this.application.id)
                .subscribe(
                  () => {
                    this.emitContractorUpdateEvent.emit(applicationInput);
                    this.loadContractorInfoForm();
                  },
                  error =>
                    console.warn(
                      `ERROR: ContractorForm.onContractorUnlisted - ${JSON.stringify(
                        error
                      )}`
                    )
                );
            },
            error => {
              if (
                error.graphQLErrors[0] &&
                error.graphQLErrors[0].message === 'Duplicate Email'
              ) {
                this.snackBar.open(
                  `Please contact us at (877) 232-4300 or info@crmp.org to add contractor information to your application.`,
                  'CONFIRM'
                );
              } else {
                this.snackBar.open(
                  `Error selecting contractor. Please contact us at (877) 232-4300 or info@crmp.org to add contractor information to your application.`,
                  'CONFIRM'
                );
              }
              console.warn(
                `ERROR: ContractorForm.onContractorUnlisted - ${JSON.stringify(
                  error
                )}`
              );
            }
          );
        }
        if(isexists){

          const Contact: IContact = data.contact as IContact;

 
          const contractorId = Contact.id;
          const applicationInput: IApplicationInput = {} as IApplicationInput;
          applicationInput.contractorTypeCode = 700000000;

      
          if(Contact.contractorInDirectory){
            applicationInput.contractorPermissionsCode = 700000000;
            applicationInput.contractorInvitationCode = 700000000;
           

          }else{
            applicationInput.contractorPermissionsCode = 700000002;
            applicationInput.contractorInvitationCode = 700000000;
     
           
          }
          applicationInput._Ebb_ContractorId = contractorId;
          this.apiApplication
          .updateApplication(applicationInput, this.application.id)
          .subscribe(
            () => {
              this.emitContractorUpdateEvent.emit(applicationInput);
              this.loadContractorInfoForm();
            },
            error =>
              console.warn(
                `ERROR: ContractorForm.onContractorUnlisted - ${JSON.stringify(
                  error
                )}`
              )
          );
        }
        }
      },
      error => {
        console.warn(
          `ERROR: ContractorForm.onContractorUnlisted - ${JSON.stringify(
            error
          )}`
        );
      }
    );
  }
public isManualContractor():Boolean{
 var ismanualcontractor = false;
if(this.application.contractor != null ){

if(this.application.contractor.contractorManualEntry != null){
  ismanualcontractor =this.application.contractor.contractorManualEntry;
}
}
return ismanualcontractor
}

public IsContractorInDirectory():Boolean{
  var isdirectorycontractor = false;
 if(this.application.contractor != null ){
 
 if(this.application.contractor.contractorInDirectory != null && this.application.contractor.contractorInDirectory == true && this.application.programType !== 700000003 && this.application.programType !== 700000004){
  isdirectorycontractor =true;
 }
 if(this.application.contractor.essContractorInDirectory != null && this.application.contractor.essContractorInDirectory == true && this.application.programType === 700000003 ){
  isdirectorycontractor =true;
 }
 if(this.application.contractor.emrContractorInDirectory != null && this.application.contractor.emrContractorInDirectory == true && this.application.programType === 700000004 ){
  isdirectorycontractor =true;
 }
 }
 return isdirectorycontractor
 }
  public onContractorReviewEvent(): void {
    const dialogContractorReviewList: DialogContractorReviewListData = {} as DialogContractorReviewListData;
    dialogContractorReviewList.contractorHireHistorys = [];

    if (this.application.contractorHireHistorys.length <= 0) {
      this.persistNewHireHistoryToCDS();
      const contractorHireHistory: IContractorHireHistory = {
        contractorid: this.application.contractor.id,
        createdOn: new Date(),
        contractorBusinessName: this.application.contractor.businessName,
        contractorReview: '',
        contractorResponse:''
      };
      dialogContractorReviewList.contractorHireHistorys.push(
        contractorHireHistory
      );
      this.application.contractorHireHistorys.push(contractorHireHistory);
    } else {
      // sort by contractor id
      this.application.contractorHireHistorys.sort((a, b) =>
        a.contractorid < b.contractorid
          ? 1
          : b.contractorid < a.contractorid
            ? -1
            : 0
      );

      let prevContractorId = '';

      // tslint:disable-next-line: forin
      for (const index in this.application.contractorHireHistorys) {
        // if contractor has not been hired twice (i.e. once in pre-retrofit and then do it myself and then hired again in post-retrofit)
        if (
          prevContractorId !==
          this.application.contractorHireHistorys[index].contractorid
        ) {
          dialogContractorReviewList.contractorHireHistorys.push({
            contractorid: this.application.contractorHireHistorys[index]
              .contractorid,
            createdOn: this.application.contractorHireHistorys[index].createdOn,
            contractorBusinessName: this.application.contractorHireHistorys[
              index
            ].contractorBusinessName,
            contractorReview: '',
            contractorResponse:''
          });
        }
        prevContractorId = this.application.contractorHireHistorys[index]
          .contractorid;
      }
    }

    // sort by date, descending
    dialogContractorReviewList.contractorHireHistorys.sort((a, b) =>
      a.createdOn < b.createdOn ? 1 : b.createdOn < a.createdOn ? -1 : 0
    );

    //take top 5
    dialogContractorReviewList.contractorHireHistorys = dialogContractorReviewList.contractorHireHistorys.slice(
      0,
      5
    );

    // get any existing reviews
    this.contractorReviews = [];
    if (this.application.contractorHireHistorys.length <= 0) {
      this.performContractorReviewDialogSteps(dialogContractorReviewList);
    } else {
      // tslint:disable-next-line: forin
      for (const index in dialogContractorReviewList.contractorHireHistorys) {
        this.loadContractorReviewData(
          this.application.id,
          dialogContractorReviewList.contractorHireHistorys[index].contractorid
        );
      }

      // Requests (to get existing reviews) have been sent. Wait for a specified time for requests to complete.
      setTimeout(() => {
        // after waiting for the specified time, confirm whether requests have completed.
        if (
          this.contractorReviews.length ===
          dialogContractorReviewList.contractorHireHistorys.length
        ) {
          this.performContractorReviewDialogSteps(dialogContractorReviewList);
        } else {
          setTimeout(() => {
            if (
              this.contractorReviews.length <
              dialogContractorReviewList.contractorHireHistorys.length
            ) {
              console.warn(
                'after two timeouts, contractor reviews have not yet been loaded...'
              );
            }
            this.performContractorReviewDialogSteps(dialogContractorReviewList);
          }, 3000);
        }
      }, 3000);
    }
  }

  private persistNewHireHistoryToCDS() {
    const contractorHireHistoryInput = {
      applicationid: this.application.id,
      contractorid: this.application.contractor.id,
      contractorBusinessName: this.application.contractor.businessName,
      name: this.application.contractor.fullName
    } as IContractorHireHistoryInput;

    this.apiContractorHireHistory
      .update(contractorHireHistoryInput)
      .subscribe(contractorHireHistoryId => {
        if (contractorHireHistoryId) {
          console.log(`New hire history record created`);
        } else {
          console.error(`ERROR creating new hire history record`);
        }
      });
  }

  private performContractorReviewDialogSteps(
    dialogContractorReviewList: DialogContractorReviewListData
  ) {
    const nonNullReviews = [];
    // tslint:disable-next-line: forin
    for (const index in this.contractorReviews) {
      if (this.contractorReviews[index] !== null) {
        nonNullReviews.push(this.contractorReviews[index]);
      }
    }
    // add existing reviews to list of hired contractors
    // tslint:disable-next-line: forin
    for (const index in dialogContractorReviewList.contractorHireHistorys) {
      const nonNullReview = nonNullReviews.find(
        reviewData =>
          reviewData.contractorid ===
          dialogContractorReviewList.contractorHireHistorys[index].contractorid
      );
      if (nonNullReview !== null && nonNullReview !== undefined) {
        dialogContractorReviewList.contractorHireHistorys[
          index
        ].contractorReview = nonNullReview.review;
        dialogContractorReviewList.contractorHireHistorys[
          index
        ].contractorResponse = nonNullReview.response;
        dialogContractorReviewList.contractorHireHistorys[
          index
        ].contractorResponseDate = nonNullReview.responseDate;
        dialogContractorReviewList.contractorHireHistorys[index].id =
          nonNullReview.id;
      }
    }

    const dialogHiredListRef = this.dialogContractorReviewList.open(
      DialogContractorReviewListComponent,
      {
        width: '600px',
        height: '700px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        data: dialogContractorReviewList
      }
    );

    dialogHiredListRef.afterClosed().subscribe(
      selectedContractor => {
        if (selectedContractor) {
          const dialogContractorReviewItem: DialogContractorReviewData = {} as DialogContractorReviewData;

          dialogContractorReviewItem.contractorName =
            selectedContractor.contractorToReviewBusinessName;
          dialogContractorReviewItem.contractorid =
            selectedContractor.contractorToReviewId;
          dialogContractorReviewItem.applicationid = this.application.id;
          dialogContractorReviewItem.review =
            selectedContractor.contractorReviewText;
          dialogContractorReviewItem.reviewid =
            selectedContractor.contractorReviewId;
            dialogContractorReviewItem.response =selectedContractor.contractorResponseText;
            dialogContractorReviewItem.responseDate =selectedContractor.contractorResponseDate;
          const dialogRef = this.dialogContractorReview.open(
            DialogContractorReviewComponent,
            {
              width: '400px',
              maxWidth: '95vw',
              maxHeight: '95vh',
              data: dialogContractorReviewItem
            }
          );

          dialogRef.afterClosed().subscribe(
            reviewData => {
              if (reviewData && reviewData.review.length > 0) {
                const contractorreviewinput: IContractorReviewInput = {} as IContractorReviewInput;
                contractorreviewinput.review = reviewData.review;
                contractorreviewinput.applicationid = this.application.id;
                contractorreviewinput.contractorid = reviewData.contractorid;
                let reviewid = '';
                if (reviewData.reviewid) {
                  reviewid = reviewData.reviewid;
                }
                this.apiContractorReview
                  .saveContractorReview(contractorreviewinput, reviewid)
                  .subscribe(
                    data => { },
                    error => {
                      console.warn(
                        `ContractorForm.performContractorReviewDialogSteps error1: ${JSON.stringify(
                          error
                        )}`
                      );
                    }
                  );
              }
            },
            error => {
              console.warn(
                `ContractorForm.performContractorReviewDialogSteps error2: ${JSON.stringify(
                  error
                )}`
              );
            }
          );
        }
      },
      error => {
        console.warn(
          `ContractorForm.performContractorReviewDialogSteps  error3:${JSON.stringify(
            error
          )}`
        );
      }
    );
  }

  private loadContractorReviewData(
    applicationid: string,
    contractorid: string
  ): void {
    this.apiContractorReview
      .getContractorReview(applicationid, contractorid)
      .subscribe(
        data => {
          this.contractorReviews.push(data);
        },
        error => {
          console.warn(
            `ContractorForm.loadContractorReviewData ${JSON.stringify(error)}`
          );
        }
      );
  }

  public setBidDisplayOptions(bidCount: number, displaySecondBid: boolean) {
    switch (bidCount) {
      case 0: {
        this.displayFirstBidLabel = 'SUBMIT';
        this.displaySecondBidLabel = 'SUBMIT';
        this.displaySecondBid = displaySecondBid;
        break;
      }
      case 1: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'SUBMIT';
        this.displaySecondBid = displaySecondBid;
        break;
      }
      case 2: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'EDIT';
        this.displaySecondBid = displaySecondBid;
        break;
      }
      default: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'EDIT';
        this.displaySecondBid = true;
        break;
      }
    }
    this.displayFirstBidLabel = this.displayFirstBidLabel + ' ESTIMATE';
  }


  public getFormattedDate(input: string): string {
    if(input == null || input === undefined){
      return "";
    }
    const permitDateUTC = new Date(input);
    permitDateUTC.setHours(permitDateUTC.getHours() + 8);

    const permitDatePST = new Date(permitDateUTC);

    const year = permitDatePST.getFullYear();

    let month = (1 + permitDatePST.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = permitDatePST.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return `${month}/${day}/${year}`;
  }

  // Delete homeowner-submitted bids for an application
  private deleteBids(applicationId: string): Observable<any> {
    return this.apiApplicationBid
      .getApplicationBidList(applicationId)
      .pipe(mergeMap((applicationBids) => {
        applicationBids = this.filterContractorBids(applicationBids)

      return from(applicationBids).pipe(
        mergeMap(bid => {
          return this.deleteBid(bid.id, bid._Ebb_ApplicationId);
        })
      );
    }));
  }

  private deleteBid(bidId: string, applicationId: string): Observable<any> {
    const bidInput = {
      id: bidId,
      _Ebb_ApplicationId: applicationId
    } as IApplicationBidInput;

    return this.apiApplicationBid.delete(bidInput)
      .pipe(map(result => {
        if (!result) {
          console.log('error deleting bid');
        } else {
          console.log('bid deleted');
        }
        return result;
      }));
  }



  public isSgQualify() : boolean  {
    return this.application.sGStatus === 700000004 && !this.isContractor();
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }

  public contractorAllowManual(): boolean {
    return this.programCycleContractorAllowManual;
  }

  private checkContractorAllowManual(): void {
  
    if (this.application.programCycle !== null && this.application.programCycle.contractorAllowManual !== null && this.application.programCycle.contractorAllowManual === true) {
      this.programCycleContractorAllowManual = true;
    }
    else {
      this.programCycleContractorAllowManual = false;
    }
  }

}